const setLocalUserInfo = (_userInfo: any) => {
  // Managed by Redux
};

const getUserInfo = () => {
  try {
    const rootPersist = localStorage.getItem("persist:root");
    if (rootPersist) {
      const parsedRoot = JSON.parse(rootPersist);
      if (parsedRoot.auth) {
        const parsedAuth = JSON.parse(parsedRoot.auth);
        return parsedAuth.user ?? null;
      }
    }
  } catch (err) {
    console.error("Failed to parse userInfo from persist:root", err);
  }
  return null;
};

const setLocalTheme = (theme: string) => {
  localStorage.setItem("theme", theme);
};

const getTheme = () => {
  const theme = localStorage.getItem("theme");
  return theme ?? "light";
};

const setLocalLanguage = (language: string) => {
  localStorage.setItem("language", language);
};

const getLanguage = () => {
  const language = localStorage.getItem("language");
  return language ?? "en";
};

const setLocalTenantId = (tenantId: string) => {
  localStorage.setItem("tenantId", tenantId);
};

const getTenantId = () => {
  const tenantId = localStorage.getItem("tenantId");
  return tenantId ?? null;
};

const setLocalAccessToken = (_accessToken: string) => {
  // Managed by Redux
};

const getAccessToken = () => {
  try {
    const rootPersist = localStorage.getItem("persist:root");
    if (rootPersist) {
      const parsedRoot = JSON.parse(rootPersist);
      if (parsedRoot.auth) {
        const parsedAuth = JSON.parse(parsedRoot.auth);
        return parsedAuth.accessToken ?? null;
      }
    }
  } catch {
    // ignore
  }
  return null;
};

const setLocalRefreshToken = (_refreshToken: string) => {
  // Managed by Redux
};

const getRefreshToken = () => {
  try {
    const rootPersist = localStorage.getItem("persist:root");
    if (rootPersist) {
      const parsedRoot = JSON.parse(rootPersist);
      if (parsedRoot.auth) {
        const parsedAuth = JSON.parse(parsedRoot.auth);
        return parsedAuth.refreshToken ?? null;
      }
    }
  } catch {
    // ignore
  }
  return null;
};

const clearLocalStorage = () => {
  localStorage.clear();
};

export {
  clearLocalStorage,
  getAccessToken, getLanguage, getRefreshToken,
  getTenantId,
  getTheme, getUserInfo,
  setLocalAccessToken, setLocalLanguage, setLocalRefreshToken,
  setLocalTenantId,
  setLocalTheme, setLocalUserInfo
};
